import { render, staticRenderFns } from "./mobile_index.vue?vue&type=template&id=458498ef&scoped=true&"
import script from "./mobile_index.vue?vue&type=script&lang=js&"
export * from "./mobile_index.vue?vue&type=script&lang=js&"
import style0 from "./mobile_index.vue?vue&type=style&index=0&id=458498ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458498ef",
  null
  
)

export default component.exports